import styles from "./Production.module.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../components/context/Auth";
import {
  DispatchReloadIcon,
  CreateVoucherIcon,
} from "../../components/icons/Icon";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
import SlidingFilter2 from "../../components/updatedComponents/Dealers/SlidingFilter2";
import Button from "../../components/updatedComponents/Dealers/Button";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import Pagination2 from "../../components/updatedComponents/FormComponents/Pagination2";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilter,
  setPagination,
  setUi,
} from "../../store/slices/production/ProductionSlice";
import { daysData, yearData } from "../../constants/constants";
import useTableHeight from "../../hooks/useTableHeight";
import useDebounce from "../../hooks/useDebounce";
import OrderFilters from "../ordermanager/OrderFilters";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import { TemplateNotFound } from "../../components/icons/Icon2";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import { formatDateTime, LastActionCell } from "../../Utils/Utils";
import ThreeDotMenu from "../../components/updatedComponents/Production/ThreeDotMenu";
import { StatusBadge } from "../../components/updatedComponents/Production/StatusBadge";

import QueueBadge from "../../components/updatedComponents/Production/QueueBadge";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import QueueEditModal from "../../components/updatedComponents/Production/QueueEditModal";
import { ProgressBar } from "../../components/updatedComponents/Production/ProgressBar";
import {
  ITEM_WISE_DUMMY,
  MACHINE_WISE_DUMMY,
  machinesData,
  ORDER_WISE_DUMMY,
  productionTypeData,
  TAB_COLUMNS,
  TAB_GRIDS,
  TAB_STATUS_CONFIG,
  TAB_STATUS_COUNTS,
  timeAgo,
  warehousesData,
} from "../../components/updatedComponents/Production/utils";
import UpdateProductionDrawer from "../../components/updatedComponents/Production/UpdateProductionDrawer";
import MobileProductionCard from "./MobileProductionCard";
import ProductionFilters from "../../components/updatedComponents/Production/ProductionFilters";

// ─── Main Production Component ────────────────────────────────────────────────
const Production = () => {
  const { mode, designations } = useAuth();
  const { filter, pagination } = useSelector((r) => r.production);
  const production = useDispatch();
  const navigate = useNavigate();
  const { show } = useToast();
  const tableRef = useRef(null);
  const dragItem = useRef(null);
  const dragOver = useRef(null);

  // ─── recompute queueNo ────────────────────────────────────────────────────────
  const requeue = (arr) => arr.map((item, i) => ({ ...item, queueNo: i + 1 }));

  useTableHeight(tableRef);
  useDebounce(filter.keyword, 700);

  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [productionQty, setProductionQty] = useState("");
  const [machine, setMachine] = useState("");
  const [warehouses, setWarehouses] = useState([]);
  useEffect(() => {
    if (warehousesData) {
      setWarehouses(
        warehousesData.map((w) => ({
          label: w.warehousename,
          value: w.warehouseId,
        })),
      );
    }
  }, []);
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    setMachines(
      machinesData.map((m) => ({
        label: m.machineName,
        value: m.machineName,
      })),
    );
  }, []);
  const [selectedMachine, setSelectedMachine] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [reFetch, setReFetch] = useState(false);

  const [queueEditItem, setQueueEditItem] = useState(null);

  const [productionTableData, setProductionTableData] = useState({
    "Order Wise": ORDER_WISE_DUMMY.map((d, i) => ({ ...d, queueNo: i + 1 })),
    "Item Wise": ITEM_WISE_DUMMY.map((d, i) => ({ ...d, queueNo: i + 1 })),
    "Production Line Wise": MACHINE_WISE_DUMMY.map((d, i) => ({
      ...d,
      queueNo: i + 1,
    })),
  });

  const [mobileProdItem, setMobileProdItem] = useState(null);

  const activeType = productionTypeData.includes(filter.voucherTab)
    ? filter.voucherTab
    : "Order Wise";

  const currentData = productionTableData[activeType] || [];
  const columns = TAB_COLUMNS[activeType];
  const gridTemplate = TAB_GRIDS[activeType];

  const statusCards = useMemo(() => {
    const config = TAB_STATUS_CONFIG[activeType];
    const counts = TAB_STATUS_COUNTS[activeType];
    return config.map((cfg, i) => ({
      status: cfg.status,
      label: cfg.label,
      count: counts[i]?.count || 0,
      allCount: counts[i]?.prevCount || 0,
      amount: counts[i]?.amount || 0,
    }));
  }, [activeType]);

  const filteredData = useMemo(() => {
    let result = [...currentData];
    if (filter.keyword) {
      const kw = filter.keyword.toLowerCase();
      result = result.filter(
        (item) =>
          (item.itemCode && item.itemCode.toLowerCase().includes(kw)) ||
          (item.orderId && String(item.orderId).toLowerCase().includes(kw)) ||
          (item.voucherNo && item.voucherNo.toLowerCase().includes(kw)) ||
          (item.customer && item.customer.toLowerCase().includes(kw)) ||
          (item.machine && item.machine.toLowerCase().includes(kw)) ||
          (item.collection && item.collection.toLowerCase().includes(kw)),
      );
    }
    if (filter.selectedFilter && filter.selectedFilter !== "All") {
      result = result.filter((item) => item.status === filter.selectedFilter);
    }
    if (activeType === "Production Line Wise" && selectedMachine) {
      result = result.filter((item) => item.machine === selectedMachine);
    }
    return result;
  }, [filter.keyword, filter.selectedFilter, currentData]);

  // ── Drag handlers ───────────────────────────────────────────────────────────
  const handleDragStart = useCallback((e, id) => {
    dragItem.current = id;
    e.dataTransfer.setData("text/plain", id);
    e.dataTransfer.effectAllowed = "move";
  }, []);

  const handleDragEnter = useCallback((e, id) => {
    e.preventDefault();
    dragOver.current = id;
  }, []);

  const handleDragEnd = useCallback(() => {
    if (!dragItem.current || !dragOver.current) return;
    setProductionTableData((prev) => {
      const arr = [...prev[activeType]];
      const fromIdx = arr.findIndex((x) => x.id === dragItem.current);
      const toIdx = arr.findIndex((x) => x.id === dragOver.current);
      if (fromIdx === -1 || toIdx === -1) return prev;
      const [moved] = arr.splice(fromIdx, 1);
      arr.splice(toIdx, 0, moved);
      return { ...prev, [activeType]: requeue(arr) };
    });
    dragItem.current = null;
    dragOver.current = null;
  }, [activeType]);

  const handleManualQueue = useCallback(
    (id, newQueue) => {
      setProductionTableData((prev) => {
        const arr = [...prev[activeType]];
        const fromIdx = arr.findIndex((d) => d.id === id);
        if (fromIdx === -1) return prev;
        const toIdx = Math.min(newQueue - 1, arr.length - 1);
        const [moved] = arr.splice(fromIdx, 1);
        arr.splice(toIdx, 0, moved);
        return { ...prev, [activeType]: requeue(arr) };
      });
    },
    [activeType],
  );

  // ── Handlers ─────────────────────────────────────────────────────────────────
  const handleDayChange = (label) => {
    const selectedFilter = daysData.find((item) => item.label === label);
    const newDayTab = selectedFilter?.value || "today";
    production(setFilter({ orderdDaysTab: newDayTab }));
    if (newDayTab !== "period") {
      production(setPagination({ pages: [] }));
      production(setFilter({ orderStartDate: "" }));
      production(setFilter({ orderEndDate: "" }));
    }
  };

  const handleVoucherChange = (v) => {
    production(setFilter({ voucherTab: v, selectedFilter: "All" }));
    production(setPagination({ page: 1 }));
  };

  const resetAllStates = () => {
    production(setPagination({ page: 1, pages: 1 }));
    production(
      setFilter({
        selectedWarehouseId: "",
        selectedManagerID: "",
        orderdDaysTab: "today",
        orderStartDate: "",
        orderEndDate: "",
        keyword: "",
        selectedFilter: "All",
        fromWarehouse: "",
        toWarehouse: "",
        meTab: "All",
        orderType: "All",
      }),
    );
    production(setUi({ isSearchBarOpen: false }));
    setLoading(false);
    setReFetch((prev) => !prev);
  };

  const isSuperAdmin = designations.includes("superadmin");

  const openUpdateModal = (item) => {
    setSelectedItem(item);
    setProductionQty("");
    setMachine(item.machine || "Extruder 1");
    setStatus(item.status || "In Production");
    setIsUpdateModalOpen(true);
  };

  const addQty = (qty) => {
    setProductionQty((prev) => (Number(prev) || 0) + qty);
  };

  const completeProduction = () => {
    if (!selectedItem) return;
    setProductionQty(selectedItem.pendingQty);
    setStatus("Ready For Dispatch");
  };

  const handleSaveProduction = () => {
    const qty = Number(productionQty);
    if (!qty || qty <= 0) {
      show("Please enter a valid production quantity.");
      return;
    }

    setProductionTableData((prev) => {
      const updated = prev[activeType].map((row) => {
        if (row.id !== selectedItem.id) return row;
        const newProduced = row.producedQty + qty;
        const newPending = Math.max(row.requiredQty - newProduced, 0);
        const isExtra = newProduced > row.requiredQty;
        const extraQty = isExtra ? newProduced - row.requiredQty : 0;

        if (isExtra) {
          show(
            `⚠️ Extra Qty Alert: ${extraQty} units exceed the required quantity. Extra Qty added to Voucher Extra Qty.`,
          );
        }

        const historyEntry = {
          qty,
          note: isExtra ? `Extra: ${extraQty} added to voucher` : "",
          ts: new Date().toISOString(),
        };

        return {
          ...row,
          machine,
          status: newPending === 0 ? "Ready For Dispatch" : status,
          producedQty: newProduced,
          pendingQty: newPending,
          updatedAt: new Date().toISOString(),
          qtyHistory: [...(row.qtyHistory || []), historyEntry],
          ...(isExtra
            ? { extraVoucherQty: (row.extraVoucherQty || 0) + extraQty }
            : {}),
        };
      });
      return { ...prev, [activeType]: updated };
    });

    setIsUpdateModalOpen(false);
  };

  // ── Render cell per column ──────────────────────────────────────────────────
  const renderCell = (col, item) => {
    switch (col.key) {
      case "createdAt":
        return (
          <div className={styles.entry} style={{ fontSize: 11 }}>
            <div style={{ fontWeight: 600, color: mode ? "#fff" : "#000000" }}>
              {item.voucherNo}
            </div>
            <div style={{ color: mode ? "#ffffff" : "#000000", marginTop: 1 }}>
              {formatDateTime(item.createdAt)}
            </div>
          </div>
        );
      case "voucherNo_Date":
        return (
          <div className={styles.entry} style={{ fontSize: 11 }}>
            <div
              title={item.voucherNo}
              style={{ fontWeight: 600, color: mode ? "#fff" : "#000000" }}
            >
              {item.voucherNo}
            </div>
            <div
              title={formatDateTime(item.createdAt)}
              style={{ color: mode ? "#ffffff" : "#000000", marginTop: 1 }}
            >
              {formatDateTime(item.createdAt)}
            </div>
          </div>
        );
      case "orderId_date":
        return (
          <div className={styles.entry} style={{ fontSize: 11 }}>
            <div
              title={item.orderId}
              style={{ fontWeight: 600, color: mode ? "#fff" : "#000000" }}
            >
              {item.orderId}
            </div>
            <div
              title={formatDateTime(item.createdAt)}
              style={{ color: mode ? "#ffffff" : "#000000", marginTop: 1 }}
            >
              {formatDateTime(item.createdAt)}
            </div>
          </div>
        );

      case "warehouse":
        return (
          <div
            className={styles.entry}
            style={{ fontSize: 11, fontWeight: 400 }}
          >
            {item.warehouse}
          </div>
        );
      case "updatedAt":
        return (
          <div className={styles.entry} title={item.updatedAt}>
            <LastActionCell lastAction={item.updatedAt} />
          </div>
        );
      case "totalItems":
        return (
          <div
            className={styles.entry}
            style={{ fontWeight: 600, fontSize: 13 }}
          >
            {item.totalItems}
          </div>
        );
      case "pendingItems":
        return (
          <div
            className={styles.entry}
            style={{
              fontWeight: 600,
              color: item.pendingItems > 0 ? "#F04438" : "#12B76A",
            }}
          >
            {item.pendingItems}
          </div>
        );
      case "totalQty":
        return (
          <div className={styles.entry}>
            {item.totalQty ?? item.requiredQty ?? "-"}
          </div>
        );
      case "pendingQty":
        return (
          <div
            className={styles.entry}
            style={{
              color: item.pendingQty > 0 ? "#F04438" : "#12B76A",
              fontWeight: 600,
            }}
          >
            {item.pendingQty}
          </div>
        );
      case "requiredQty":
        return <div className={styles.entry}>{item.requiredQty}</div>;
      case "producedQty":
        return (
          <div
            className={styles.entry}
            style={{ color: "#12B76A", fontWeight: 600 }}
          >
            {item.producedQty}
          </div>
        );
      case "progress":
        return (
          <div style={{ width: "100%", paddingRight: 4 }}>
            <ProgressBar
              produced={item.producedQty}
              required={item.requiredQty || item.totalQty || 1}
              mode={mode}
            />
          </div>
        );
      case "status":
        return <StatusBadge status={item.status} mode={mode} />;
      case "priority":
        return (
          <div
            className={styles.urgentBadge}
            style={{
              backgroundColor:
                item.priority === "Normal" ? "#4164E3" : "#f04438",
            }}
          >
            {item.priority}
          </div>
        );
      case "machine":
        return (
          <div className={styles.entry} style={{ fontSize: 12 }}>
            {item.machine ?? "-"}
          </div>
        );
      case "itemCode":
        return <div className={styles.entry}>{item.itemCode ?? "-"}</div>;
      case "collection":
        return <div className={styles.entry}>{item.collection ?? "-"}</div>;
      case "customer":
        return (
          <div className={styles.entry} style={{ fontSize: 12 }}>
            {item.customer ?? "-"}
          </div>
        );
      case "action":
        return (
          <ThreeDotMenu
            item={item}
            mode={mode}
            onUpdate={openUpdateModal}
            onQueueEdit={(it) => setQueueEditItem(it)}
            onCancel={(it) => {
              if (
                window.confirm(
                  `Cancel order for ${it.voucherNo || it.orderId || it.machine}?`,
                )
              ) {
                setProductionTableData((prev) => ({
                  ...prev,
                  [activeType]: prev[activeType].map((r) =>
                    r.id === it.id ? { ...r, status: "Cancelled" } : r,
                  ),
                }));
                show("Order cancelled.");
              }
            }}
          />
        );
      default:
        return <div className={styles.entry}>{item[col.key] ?? "-"}</div>;
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  const currentItem = selectedItem
    ? productionTableData[activeType]?.find((r) => r.id === selectedItem.id) ||
      selectedItem
    : null;

  return (
    <div
      className={styles.production}
      style={mode ? { backgroundColor: "#2C2E33", border: "none" } : {}}
    >
      {/* queue edit modal */}
      {queueEditItem && (
        <QueueEditModal
          item={queueEditItem}
          maxQueue={currentData.length}
          mode={mode}
          onConfirm={(n) => handleManualQueue(queueEditItem.id, n)}
          onClose={() => setQueueEditItem(null)}
          activeType={activeType}
        />
      )}

      {/* ── TOP BAR ── */}
      <div className={styles.production_top}>
        <div className={styles.production_top_left}>
          <TopTabBar text={"Production"} />
        </div>
        <div className={styles.production_right}>
          <div>
            <SlidingFilter2
              itemList={daysData.map((item) => item.label)}
              setFilter={handleDayChange}
              selectedItem={
                daysData.find((item) => item.value === filter.orderdDaysTab)
                  ?.label
              }
            />
          </div>

          {filter.orderdDaysTab === "period" && (
            <>
              <div className={styles.period}>
                <InputTypedate
                  text={"From"}
                  value={filter.orderStartDate}
                  max={filter.orderEndDate}
                  onChange={(e) => {
                    production(setFilter({ orderStartDate: e.target.value }));
                    production(setFilter({ selectedFilter: "" }));
                  }}
                />
              </div>
              {filter.orderStartDate !== "" && (
                <div className={styles.period}>
                  <InputTypedate
                    text={"To"}
                    value={filter.orderEndDate}
                    min={filter.orderStartDate}
                    onChange={(e) => {
                      production(setFilter({ orderEndDate: e.target.value }));
                      production(setFilter({ selectedFilter: "" }));
                    }}
                  />
                </div>
              )}
            </>
          )}

          {isSuperAdmin && (
            <div className={styles.financialYear}>
              <DropDown
                label={"F.Y."}
                listLabel={"2025-2026"}
                options={yearData}
                onSelect={(option) =>
                  production(setFilter({ selectedYear: option.label }))
                }
                onReject={() => production(setFilter({ selectedYear: null }))}
              />
            </div>
          )}

          <div className={styles.reload}>
            <Button
              buttonIcon={<DispatchReloadIcon />}
              buttonBgColor={"#000000"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={resetAllStates}
            />
          </div>
          <div>
            <Button
              buttonIcon={<CreateVoucherIcon />}
              buttonText={"Manage Production"}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonBorder={"none"}
              buttonClick={() => navigate("/production/create")}
            />
          </div>
          <div className={styles.pegination}>
            <Pagination2
              mode={mode}
              currentPage={pagination.page}
              setCurrentPage={(newPage) =>
                production(setPagination({ page: newPage }))
              }
              totalPages={pagination.pages}
            />
          </div>
        </div>
      </div>

      {/* ── STATUS CARDS ── */}
      <div>
        <div
          className={styles.production_filters}
          style={
            mode ? { borderColor: "#232529", backgroundColor: "#232529" } : {}
          }
        >
          <ProductionFilters
            mode={mode}
            headerData={statusCards}
            selectedFilter={filter.selectedFilter}
            handleClick={(s) => {
              production(setFilter({ selectedFilter: s }));
              production(setPagination({ page: 1 }));
            }}
            type={"production"}
          />
        </div>
      </div>

      {/* ── DATA SECTION ── */}
      <div className={styles.production_data}>
        <div className={styles.production_data_filters}>
          <div>
            <SearchBar
              placeholder={"Search"}
              value={filter.keyword}
              onChange={(e) => {
                production(setFilter({ keyword: e.target.value }));
                production(setPagination({ page: 1 }));
              }}
            />
          </div>
          <div>
            <SlidingFilter2
              itemList={productionTypeData}
              setFilter={handleVoucherChange}
              selectedItem={activeType}
            />
            <DropDown
              label={"Warehouse"}
              listLabel={"All"}
              options={warehouses}
              onSelect={(option) =>
                production(setFilter({ selectedWarehouseId: option.value }))
              }
              onReject={() =>
                production(setFilter({ selectedWarehouseId: null }))
              }
            />

            {activeType === "Production Line Wise" && (
              <DropDown
                label={"Machine"}
                listLabel={selectedMachine || "All"}
                options={machines}
                onSelect={(option) => {
                  setSelectedMachine(option.value);
                }}
                onReject={() => {
                  setSelectedMachine("");
                }}
              />
            )}
          </div>
        </div>

        {/* ── TABLE ── */}
        <div ref={tableRef}>
          <ul className={styles.production_data_list}>
            <div className={styles.production_data_list}>
              {/* Header */}
              <li
                className={`${styles.production_data_list_row_header} ${mode ? styles.production_data_list_row_header_dark : ""}`}
                style={{ gridTemplateColumns: gridTemplate }}
              >
                <div title="Queue">Queue</div>
                {columns.map((col) => (
                  <div key={col.key} title={col.label}>
                    {col.label}
                  </div>
                ))}
              </li>

              {/* Rows */}
              {filteredData.map((item) => (
                <li
                  key={item.id}
                  // draggable
                  // onDragStart={(e) => handleDragStart(e, item.id)}
                  // onDragEnter={(e) => handleDragEnter(e, item.id)}
                  // onDragOver={(e) => e.preventDefault()}
                  // onDrop={handleDragEnd}
                  className={`${styles.production_data_list_row} ${mode ? styles.production_data_list_row_dark : ""}`}
                  style={{
                    gridTemplateColumns: gridTemplate,
                    //  cursor: "grab"
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (activeType === "Item Wise") return;
                    navigate(
                      `/production/productionDetails/${item.orderId || item.id}`,
                      {
                        state: {
                          tabType:
                            activeType === "Production Line Wise"
                              ? "Machine Wise"
                              : "Order Wise",
                          status: item?.status,
                        },
                      },
                    );
                  }}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    {/* <QueueBadge
                      value={item.queueNo}
                      onUpdate={(n) => handleManualQueue(item.id, n)}
                      mode={mode}
                    /> */}

                    <div className={styles.entry} title={item.queueNo}>
                      {item.queueNo}
                    </div>
                  </div>
                  {columns.map((col) => (
                    <div
                      key={col.key}
                      title={String(item[col.key] ?? "")}
                      className={styles.tableCell}
                      onClick={
                        col.key === "action"
                          ? (e) => e.stopPropagation()
                          : undefined
                      }
                    >
                      {renderCell(col, item)}
                    </div>
                  ))}
                </li>
              ))}

              {filteredData.length === 0 && (
                <div className={styles.no_data}>
                  <NoDataFound
                    icon={<TemplateNotFound />}
                    textTitle={"No Data Found"}
                  />
                </div>
              )}
            </div>
          </ul>
        </div>

        <div className={styles.mobileCards}>
          {filteredData.map((item) => (
            <MobileProductionCard
              key={item.id}
              item={item}
              mode={mode}
              onUpdate={(selectedItem) => {
                setMobileProdItem(selectedItem);
                setIsUpdateModalOpen(true);
              }}
            />
          ))}
        </div>

        {/* ── UPDATE DRAWER ── */}
        {isUpdateModalOpen && currentItem && (
          <UpdateProductionDrawer
            open={isUpdateModalOpen}
            currentItem={currentItem}
            mode={mode}
            productionQty={productionQty}
            setProductionQty={setProductionQty}
            machine={machine}
            setMachine={setMachine}
            status={status}
            setStatus={setStatus}
            addQty={addQty}
            completeProduction={completeProduction}
            handleSaveProduction={handleSaveProduction}
            onClose={() => setIsUpdateModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};

export default Production;
